import { useEffect } from 'react';

import { useLayoutStore } from '@/stores/layout-store';
import { Sidebar } from './Sidebar';
import { WorkspaceSwitcher } from './WorkspaceSwitcher';
import { SidebarSearch } from './SidebarSearch';
import { SidebarNav } from './SidebarNav';
import { SidebarFooter } from './SidebarFooter';

/** The team sidebar — workspace switcher + search + nav, with the user footer. */
export function AppSidebar() {
  const toggleSearch = useLayoutStore((s) => s.toggleSearch);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        toggleSearch();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [toggleSearch]);

  return (
    <Sidebar
      header={
        <>
          <WorkspaceSwitcher />
          <SidebarSearch />
        </>
      }
      footer={<SidebarFooter />}
    >
      <SidebarNav />
    </Sidebar>
  );
}
